module.exports = __webpack_public_path__ + "../resources/img/ic_plus_gray950.ef830b52.svg";